const COLOR_PALETTE = [
  '#017AFF',
  '#6C47FF',
  '#39C0C8',
  '#F34971',
  '#F96300',
  '#F439BF',
  '#F5C900',
  '#CDAD7A',
  '#C3E42A',
  '#20BF6C',
];

export const getColorByIndex = (i: number) => {
  return COLOR_PALETTE[i % COLOR_PALETTE.length];
};

// const COLOR_PALETTE = [
//   '#1AB99B',
//   '#F0C514',
//   '#81CCB8',
//   '#8798CC',
//   '#CE7057',
//   '#4ABA70',
//   '#F59D1F',
//   '#517F72',
//   '#55607E',
//   '#7F4537',
//   '#20A286',
//   '#E77E23',
//   '#6FC387',
//   '#7D649B',
//   '#CE8552',
//   '#26AF5F',
//   '#D45729',
//   '#4B8056',
//   '#3F324E',
//   '#805334',
//   '#3597D4',
//   '#E84C3D',
//   '#86B6CD',
//   '#CC66A5',
//   '#CC9181',
//   '#2481BC',
//   '#C23A2C',
//   '#54747F',
//   '#80426B',
//   '#805B53',
//   '#975BA5',
//   '#EEF3F6',
//   '#67B9CE',
//   '#CE4C4C',
//   '#CCB394',
//   '#894B9E',
//   '#BDC2C8',
//   '#427681',
//   '#802F35',
//   '#7F6E5E',
//   '#34495E',
//   '#93A5A5',
//   '#4383C3',
//   '#CD4760',
//   '#E4C15B',
//   '#2D3E50',
//   '#808E8E',
//   '#275680',
//   '#802D3F',
//   '#B39147',
// ];
